import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vue-calendar__container" }
const _hoisted_2 = {
  key: 0,
  class: "container__year"
}
const _hoisted_3 = ["onClick"]

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { PropType, computed, onMounted, reactive, ref } from 'vue';
import dayjs from 'dayjs';
import MonthCalendar from '@/components/calendar/calendarComponents/MonthCalendar.vue';

// interface
/**
 * Props用のinterface
 */
interface Props {
  showYearSelector?: boolean;
  organizationId?: string;
  changeColor?: string;
  activeDates?: Array<any>;
  value?: string | number;
  activeClass?: string;
  prefixClass?: string;
  hideWeekend?: boolean;
  hideSunday?: boolean;
}

/**
 * state用のinterface
 */
interface IYearCalendar {
  isUsingString: boolean | number;
  localLang: string;
}

// props
// propsのdefaultを設定

export default /*@__PURE__*/_defineComponent({
  __name: 'YearCalendar',
  props: {
    showYearSelector: { type: Boolean, default: true },
    organizationId: { default: '' },
    changeColor: { default: 'red' },
    activeDates: { default: () => [] },
    value: { default: dayjs().year() },
    activeClass: { default: '' },
    prefixClass: { default: 'calendar--active' },
    hideWeekend: { type: Boolean, default: false },
    hideSunday: { type: Boolean, default: false }
  },
  emits: ["input", "toggleDate", "update:activeDates", "monthClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

// style variables
// const Wrapper = styled.section`
//   padding: 4em;
//   background: papayawhip;
// `;

//変数
// i18n対応
const t = i18n.t;
// state変数
const state: IYearCalendar = reactive<IYearCalendar>({ isUsingString: true, localLang: 'ja' }) as IYearCalendar;

//computed
/**
 * 言語設定の取得
 * ローカルの言語設定コードを取得する
 */
const lang = computed(() => {
  return i18n.locale;
});

/**
 * 月を構成する日付オブジェクトの作成・更新を行う(多分)
 */
const month = computed((): object => {
  const month = {};
  props.activeDates.forEach((date) => {
    let oDate;
    if (typeof date === 'string') {
      oDate = {
        date: date,
        className: props.activeClass,
      };
    } else {
      // activeDateのオブジェクトにclassName属性がない場合、自動的に空文字列が入ります。 そうでない場合は、未定義になります。
      oDate = {
        date: date.date,
        className: date.className || '',
      };
    }
    if (!month[dayjs(oDate.date).year()]) {
      month[dayjs(oDate.date).year()] = {};
    }
    // if (dayjs(oDate.date).year() !== parseInt(this.value)) return // 讓2020年1月的資料，不會放到 2019年的1月資料裡
    const m = (dayjs(oDate.date).month() + 1).toString();
    if (!month[dayjs(oDate.date).year()][m]) month[dayjs(oDate.date).year()][m] = [];
    month[dayjs(oDate.date).year()][m].push(oDate);
  });
  return month;
});

/**
 *
 */
const carryForwardFunction = computed(() => {
  let defaultFunction = (monthTitle) => String(monthTitle);
  switch (lang.value) {
    case 'ja':
      const year = String(activeYear.value + 1);
      defaultFunction = function (monthTitle) {
        return year + '年' + monthTitle;
      };
  }
  return defaultFunction;
});

/**
 * 稼働日カレンダーで選択される年度情報
 */
let activeYear = computed({
  get() {
    return props.value as number; // props.valueは、外側のv-model="year "から渡された値である。
  },
  set(val) {
    emits('input', val);
  },
});

// イベント
onMounted(() => {
  checkUsingString();
});

//関数
/**
 * props.activeDatesの存在確認とprops.activeDatesがstring[]かの確認
 * typeof props.activeDates[0] === 'string'がいるか怪しい
 * CalendarTable.vueの方で、activeDates: [] as ActiveDate[]で置かれているため、あり得ないんじゃないか?
 */
const checkUsingString = (): void => {
  state.isUsingString = props.activeDates.length && typeof props.activeDates[0] === 'string';
};

/**
 * 年度の切り替え
 * @param idx 年度のインデックス
 */
const changeYear = (idx: number): void => {
  activeYear.value = idx + activeYear.value - 3;
};

/**
 * 稼働日カレンダーの年度ラベルの表示部分
 * @param year 年
 */
const processYear = (year) => {
  let yearString = String(year);
  switch (lang.value) {
    case 'ja':
      yearString = yearString + '年度';
      break;
  }
  return yearString;
};

/**
 * 稼働日情報の更新
 * カレンダーの日付部分を選択した情報をもとに稼働日(登録年月日情報)の更新を行う
 * サーバーとのやりとりは無い、ここではあくまでオブジェクトの更新
 * なんでここにある?
 * @param dateObj 年月日の情報が入ったオブエクと
 */
const toggleDate = (dateObj) => {
  const activeDate = dayjs()
    .set('year', dateObj.year)
    .set('month', dateObj.month - 1)
    .set('date', dateObj.date)
    .format('YYYY-MM-DD');
  emits('toggleDate', {
    date: activeDate,
    selected: dateObj.selected,
    className: dateObj.className,
    organizationId: dateObj.organizationId,
  });

  let dateIndex;
  let newDates;

  if (state.isUsingString) {
    dateIndex = props.activeDates.indexOf(activeDate);
    newDates = modifiedActiveDates(dateIndex, activeDate);
  } else {
    const oDate = {
      date: activeDate,
      className: dateObj.className, // 本来はthis.defaultClassNameだが、バグを修正した
    };

    dateIndex = props.activeDates.indexOf(props.activeDates.find((i) => i.date === activeDate));
    newDates = modifiedActiveDates(dateIndex, oDate);
  }
  emits('update:activeDates', newDates);
};

/**
 * 稼働日の切り替え処理
 * カレンダーの日付部分をポチった時に状態を切り替えてるやつ
 * @param dateIndex 日付のインデックス
 * @param activeDate 稼働日情報
 */
const modifiedActiveDates = (dateIndex, activeDate) => {
  const newDates = [...props.activeDates];
  if (dateIndex === -1) {
    newDates.push(activeDate);
  } else {
    newDates.splice(dateIndex, 1);
  }
  return newDates;
};
const monthClick = (monthYearInfo) => {
  emits('monthClick', monthYearInfo);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showYearSelector)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("span", {
              key: i,
              class: "year__chooser",
              onClick: ($event: any) => (changeYear(i))
            }, _toDisplayString(processYear(i + _unref(activeYear) - 3)), 9, _hoisted_3)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container__months", { 'hide-weekend': _ctx.hideWeekend, 'hide-sunday': _ctx.hideSunday }])
    }, [
      (month.value[_unref(activeYear)])
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(9, (n) => {
            return _createVNode(MonthCalendar, {
              key: `month-${n + 3}-${_unref(activeYear)}`,
              class: "container__month",
              year: _unref(activeYear),
              month: n + 3,
              "active-dates": month.value[_unref(activeYear)][n + 3],
              "organization-id": _ctx.organizationId,
              "active-class": _ctx.activeClass,
              "prefix-class": _ctx.prefixClass,
              lang: lang.value,
              onToggleDate: toggleDate,
              onMonthClickEvent: monthClick
            }, null, 8, ["year", "month", "active-dates", "organization-id", "active-class", "prefix-class", "lang"])
          }), 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(9, (n) => {
            return _createVNode(MonthCalendar, {
              key: `month-${n + 3}-${_unref(activeYear)}`,
              class: "container__month",
              year: _unref(activeYear),
              month: n + 3,
              "organization-id": _ctx.organizationId,
              "active-class": _ctx.activeClass,
              "prefix-class": _ctx.prefixClass,
              lang: lang.value,
              onToggleDate: toggleDate,
              onMonthClickEvent: monthClick
            }, null, 8, ["year", "month", "organization-id", "active-class", "prefix-class", "lang"])
          }), 64)),
      (month.value[_unref(activeYear) + 1])
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(3, (n) => {
            return _createVNode(MonthCalendar, {
              key: `month-${n}-${_unref(activeYear) + 1}`,
              class: "container__month",
              year: _unref(activeYear) + 1,
              month: n,
              "active-dates": month.value[_unref(activeYear) + 1][n],
              "active-class": _ctx.activeClass,
              lang: lang.value,
              "organization-id": _ctx.organizationId,
              "prefix-class": _ctx.prefixClass,
              "process-month-title": carryForwardFunction.value,
              onToggleDate: toggleDate,
              onMonthClickEvent: monthClick
            }, null, 8, ["year", "month", "active-dates", "active-class", "lang", "organization-id", "prefix-class", "process-month-title"])
          }), 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, _renderList(3, (n) => {
            return _createVNode(MonthCalendar, {
              key: `month-${n}-${_unref(activeYear) + 1}`,
              class: "container__month",
              year: _unref(activeYear) + 1,
              month: n,
              "active-class": _ctx.activeClass,
              lang: lang.value,
              "organization-id": _ctx.organizationId,
              "prefix-class": _ctx.prefixClass,
              "process-month-title": carryForwardFunction.value,
              onToggleDate: toggleDate,
              onMonthClickEvent: monthClick
            }, null, 8, ["year", "month", "active-class", "lang", "organization-id", "prefix-class", "process-month-title"])
          }), 64)),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"container__month p-0\" data-v-74b8aabd></div><div class=\"container__month p-0\" data-v-74b8aabd></div><div class=\"container__month p-0\" data-v-74b8aabd></div><div class=\"container__month p-0\" data-v-74b8aabd></div><div class=\"container__month p-0\" data-v-74b8aabd></div>", 5))
    ], 2)
  ]))
}
}

})